import { render, staticRenderFns } from "./UpdateAdminProfileRole.vue?vue&type=template&id=69744b36&"
import script from "./UpdateAdminProfileRole.vue?vue&type=script&lang=js&"
export * from "./UpdateAdminProfileRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports